import { CloudActions } from '@portal/portal-core';

import { ccTypes } from '../shared';
import {
  SUPER_ADMIN_LICENSE_FETCH_RESUME,
  SUPER_ADMIN_LICENSE_FETCH_SUCCESS,
  SUPER_ADMIN_LICENSE_FETCH_FAILED,
  SUPER_ADMIN_CONTINUE_LICENSE_SYNC,
  SUPER_ADMIN_DISMISS_LICENSE_SYNC,
} from '../types';

type LicenseRequestState = {
  currentRequest?: number;
  requestsCount?: number;
  ccType?: string;
  syncFailed?: boolean;
  error?: string | null;
  [key: string]: unknown;
};

interface LicenseRequestAction {
  type: string;
  requestData?: LicenseRequestState;
  error?: string;
  ccType?: string;
}

const initialState: LicenseRequestState = {};

const LicenseRequest = (
  state: LicenseRequestState = initialState,
  action: LicenseRequestAction,
): LicenseRequestState => {
  switch (action.type) {
    case CloudActions.ADMIN_GET_INDIVIDUAL_LICENSES_VERBOSE:
      return {
        currentRequest: 0,
        requestsCount: 1,
        ccType: ccTypes.individual,
        syncFailed: false,
        error: null,
      };
    case CloudActions.ADMIN_GET_INSTITUTIONAL_LICENSES_VERBOSE:
      return {
        currentRequest: 0,
        requestsCount: 1,
        ccType: ccTypes.institutional,
        syncFailed: false,
        error: null,
      };
    case CloudActions.ADMIN_GET_COST_CENTERS_VERBOSE:
      return {
        ...state,
        syncFailed: false,
        error: null,
      };
    case SUPER_ADMIN_CONTINUE_LICENSE_SYNC:
      return {
        currentRequest: 0,
        requestsCount: 1,
        ccType: action.ccType || state.ccType,
        syncFailed: false,
        error: null,
      };
    case SUPER_ADMIN_DISMISS_LICENSE_SYNC:
      return {
        ...state,
        syncFailed: false,
        currentRequest: 0,
        requestsCount: 0,
        nextRequest: 1,
        error: null,
      };
    case SUPER_ADMIN_LICENSE_FETCH_RESUME:
      return {
        ...state,
        ...(action.requestData || {}),
        syncFailed: false,
        error: null,
      };
    case SUPER_ADMIN_LICENSE_FETCH_SUCCESS:
      return {
        ...(action.requestData || {}),
        syncFailed: false,
        error: null,
      };
    case SUPER_ADMIN_LICENSE_FETCH_FAILED:
      return {
        ...(action.requestData || {}),
        syncFailed: true,
        error: action.error || null,
      };
    default:
      return state;
  }
};

export default LicenseRequest;
